<div *ngIf="fascicolo" aria-live="polite">
    <div class="row">
        <div class="pda-cons-anon-section">
            <h3 class="pda-cons-anon-title">Dati Generali</h3>
            <div class="col-sm-6">
                <p>
                    <span id="numeroRuolo-label" class="pda-cons-anon-label">Numero ruolo: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="numeroRuolo-label">{{ replaceNull(fascicolo.numeroRuolo) }}</span>
                </p>
                <p>
                    <span id="annoRuolo-label" class="pda-cons-anon-label">Anno ruolo: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="annoRuolo-label">{{ replaceNull(fascicolo.annoRuolo) }}</span>
                </p>
                <p>
                    <span id="rito-label" class="pda-cons-anon-label">Rito: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="rito-label">{{ replaceNull(fascicolo.rito) }}</span>
                </p>
                <p>
                    <span id="soggetto-label" class="pda-cons-anon-label">Soggetto: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="soggetto-label">{{ replaceNull(fascicolo.soggetto) }}</span>
                </p>
                <p>
                    <span id="debitore-label" class="pda-cons-anon-label">Debitore: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="debitore-label">{{ replaceNull(fascicolo.debitore) }}</span>
                </p>
                <p>
                    <span id="stato-label" class="pda-cons-anon-label">Stato: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="stato-label">{{ replaceNull(fascicolo.stato) }}</span>
                </p>
                <p>
                    <span id="sezione-label" class="pda-cons-anon-label">Sezione: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="sezione-label">{{ replaceNull(fascicolo.sezione) }}</span>
                </p>
                <p>
                    <span id="giudice-label" class="pda-cons-anon-label">Giudice: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="giudice-label">{{ replaceNull(fascicolo.giudice) }}</span>
                </p>
                <p>
                    <span id="tipoUdienza-label" class="pda-cons-anon-label">Tipo udienza: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="tipoUdienza-label">{{ replaceNull(fascicolo.tipoUdienza) }}</span>
                </p>
                <p>
                    <span id="esitoSentenza-label" class="pda-cons-anon-label">Esito sentenza: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="esitoSentenza-label">{{ replaceNull(fascicolo.esitoSentenza) }}</span>
                </p>
            </div>
            <div class="col-sm-6">
                <p>
                    <span id="dataRegistrazione-label" class="pda-cons-anon-label">Data registrazione: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="dataRegistrazione-label">
                        {{ !!fascicolo.dataRegistrazione
                        ? (fascicolo.dataRegistrazione | date: "dd/MM/yyyy HH:mm")
                        : '-' }}
                    </span>
                </p>
                <p>
                    <span id="dataCitazione-label" class="pda-cons-anon-label">Data citazione: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="dataCitazione-label">
                        {{ !!fascicolo.dataCitazione
                        ? (fascicolo.dataCitazione | date: "dd/MM/yyyy HH:mm")
                        : '-' }}
                    </span>
                </p>
                <p>
                    <span id="dataProssimaUdienza-label" class="pda-cons-anon-label">Data prossima udienza: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="dataProssimaUdienza-label">
                    {{ !!fascicolo.dataProssimaUdienza
                    ? (fascicolo.dataProssimaUdienza | date: "dd/MM/yyyy HH:mm")
                    : '-' }}
                    </span>
                </p>
                <p>
                    <span id="dataProssimaUdienzaPassiva-label" class="pda-cons-anon-label">Data prossima udienza passiva: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="dataProssimaUdienzaPassiva-label">
                        {{ !!fascicolo.dataProssimaUdienzaPassiva
                        ? (fascicolo.dataProssimaUdienzaPassiva | date: "dd/MM/yyyy HH:mm")
                        : '-' }}
                    </span>
                </p>
                <p>
                    <span id="dataProssimaUdienzaVendita-label" class="pda-cons-anon-label">Data prossima udienza vendita: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="dataProssimaUdienzaVendita-label">
                        {{ !!fascicolo.dataProssimaUdienzaVendita
                        ? (fascicolo.dataProssimaUdienzaVendita | date: "dd/MM/yyyy HH:mm")
                        : '-' }}
                    </span>
                </p>
                <p>
                    <span id="numeroSentenza-label" class="pda-cons-anon-label">Numero sentenza: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="numeroSentenza-label"> {{ replaceNull(fascicolo.numeroSentenza) }} </span>
                </p>
                <p>
                    <span id="annoSentenza-label" class="pda-cons-anon-label">Anno sentenza: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="annoSentenza-label"> {{ replaceNull(fascicolo.annoSentenza) }} </span>
                </p>
                <p>
                    <span id="numeroDecreto-label" class="pda-cons-anon-label">Numero decreto: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="numeroDecreto-label"> {{ replaceNull(fascicolo.numeroDecreto) }} </span>
                </p>
                <p>
                    <span id="annoDecreto-label" class="pda-cons-anon-label">Anno decreto: </span>
                    <span class="pda-cons-anon-value" aria-labelledby="annoDecreto-label"> {{ replaceNull(fascicolo.annoDecreto) }} </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="fascicolo.parti?.length">
        <div class="pda-cons-anon-section">
            <h3 class="pda-cons-anon-title">Parti</h3>
            <table class="table">
                <caption class="sr-only">Lista Parti Fascicolo Anonimo</caption>
                <thead>
                    <tr>
                        <th scope="col" class="col-xs-3 pda-cons-anon-label">Nominativo</th>
                        <th scope="col" class="col-xs-3 pda-cons-anon-label">Codice Fiscale</th>
                        <th scope="col" class="col-xs-3 pda-cons-anon-label">Tipo</th>
                        <th scope="col" class="col-xs-3 pda-cons-anon-label">Avvocato</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let parte of fascicolo.parti">
                        <td class="col-xs-3 cell pda-cons-anon-value">{{ getNominativo(parte) }}</td>
                        <td class="col-xs-3 cell pda-cons-anon-value">{{ replaceNull(parte.codiceFiscale) }}
                        </td>
                        <td class="col-xs-3 cell pda-cons-anon-value">{{ replaceNull(parte.tipo) }}</td>
                        <td class="col-xs-3 cell pda-cons-anon-value">{{ replaceNull(parte.avvocato) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row" *ngIf="fascicolo.eventi?.length">
        <div class="pda-cons-anon-section">
            <h3 class="pda-cons-anon-title">Eventi</h3>
            <table class="table">
                <caption class="sr-only">Lista Eventi Fascicolo Anonimo</caption>
                <thead>
                    <tr>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Descrizione</th>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Data</th>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Data registro</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let evento of fascicolo.eventi">
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ replaceNull(evento.descrizione) }}
                        </td>
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ !!evento.data
                            ? (evento.data | date: "dd/MM/yyyy HH:mm")
                            : '-' }}</td>
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ !!evento.dataRegistro
                            ? (evento.dataRegistro | date: "dd/MM/yyyy HH:mm")
                            : '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row" *ngIf="fascicolo.curatori?.length">
        <div class="pda-cons-anon-section">
            <h3 class="pda-cons-anon-title">Curatori</h3>
            <table class="table">
                <caption class="sr-only">Lista Curatori Fascicolo Anonimo</caption>
                <thead>
                    <tr>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Nome</th>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Cognome</th>
                        <th scope="col" class="col-xs-4 pda-cons-anon-label">Tipo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let curatore of fascicolo.curatori">
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ replaceNull(curatore.nome) }}</td>
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ replaceNull(curatore.cognome) }}
                        </td>
                        <td class="col-xs-4 cell pda-cons-anon-value">{{ replaceNull(curatore.tipo) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>